Controller.$inject = ['$scope', '$element', '$timeout'];

function Controller($scope, $element, $timeout) {
    let self = this;
    self.orientation = $scope.$parent.$parent.$huiStepper?.orientation || 'horizontal';

    self.$postLink = () => {
        $timeout(() => {
            if (self.orientation === 'horizontal') {
                const preStepElement = $element[0].querySelector('.pre-step');
                const postStepElement = $element[0].querySelector('.post-step');
                const stepLabelElement = $element[0].querySelector('.hui-step-label');

                if (preStepElement && stepLabelElement) {
                    const preStepWidth = preStepElement.offsetWidth;
                    const postStepWidth = postStepElement.offsetWidth;
                    stepLabelElement.style.width = preStepWidth+postStepWidth > 0 ? `${preStepWidth+postStepWidth}px`: '';
                }
            }
        });
    };
}

export function HuiStep() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            active: '<',
            complete: '<',
            hasError: '<',
            hasWarning: '<?',
            visited: '<?'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            'stepButton': '?huiStepButton',
            'label': '?huiStepLabel',
        },
        template: ($element, $attrs) => {
            return `
                <div class="hui-step"
                     ng-class="[
                           $huiCtrl.active ? 'active' : '',
                           $huiCtrl.complete ? 'completed' : '',
                           $huiCtrl.hasWarning ? 'has-warning' : '',
                           $huiCtrl.visited ? 'visited' : '',
                           $huiCtrl.hasError ? 'in-completed' : ''
                       ]">
                    <div class="hui-step-item" ng-if="$huiCtrl.orientation === 'horizontal'">
                         <div class="step-details">
                            <ng-transclude ng-transclude-slot="stepButton"></ng-transclude>
                            <div class="hui-step-label">
                                <ng-transclude ng-transclude-slot="label"></ng-transclude> 
                            </div>
                         </div>
                         <hui-step-separator class="pre-step"></hui-step-separator>
                         <hui-step-separator class="post-step"></hui-step-separator>
                    </div>
                    <div class="hui-step-item" ng-if="$huiCtrl.orientation === 'vertical'">
                         <div class="step-details">
                            <ng-transclude ng-transclude-slot="stepButton"></ng-transclude>
                            <hui-step-separator class="pre-step"></hui-step-separator>
                         </div>
                         <div class="hui-step-label">
                             <ng-transclude ng-transclude-slot="label"></ng-transclude> 
                         </div>
                    </div>
                </div>
            `;
        }
    };
}